import {
  Favorite,
  FavoriteReference,
  FavoriteType,
  Goal,
  LifeArea,
  Tag,
  Task,
} from '@griply/types';

import { isNotFrozen } from './task-predicates';

export type ResolveFavoritesOptions = {
  favoriteRefs: FavoriteReference[];
  goals: Goal[];
  tasks: Task[];
  lifeAreas: LifeArea[];
  tags: Tag[];
};

export const resolveFavorites = ({
  favoriteRefs,
  goals,
  tasks,
  lifeAreas,
  tags,
}: ResolveFavoritesOptions): Favorite[] =>
  favoriteRefs.reduce<Favorite[]>((acc, { type, id }) => {
    if (type === FavoriteType.Goal) {
      const goal = goals.find((g) => g.id === id && !g.archivedAt);
      if (goal) {
        acc.push({ id: goal.id, type, value: goal });
      }
      return acc;
    }

    if (type === FavoriteType.Task) {
      // Goals and life areas below deliberately keep theirs: their cards lock and open the paywall.
      const task = tasks.find(
        (t) => t.id === id && !t.archivedAt && isNotFrozen(t),
      );
      if (task) {
        acc.push({ id: task.id, type, value: task });
      }
      return acc;
    }

    if (type === FavoriteType.LifeArea) {
      const lifeArea = lifeAreas.find((la) => la.id === id && !la.archivedAt);
      if (lifeArea) {
        acc.push({ id: lifeArea.id, type, value: lifeArea });
      }
      return acc;
    }

    if (type === FavoriteType.Tag) {
      const tag = tags.find((t) => t.id === id);
      if (tag) {
        acc.push({ id: tag.id, type, value: tag });
      }
    }

    return acc;
  }, []);
